import { booleanValidation, numberValidation, sortValidation, stringValidation } from '../params.validators';
import { Sorts } from './sorts.type';

type ParamsConfigValidators = {
  [K in keyof ParamsConfig]: (value: any) => any | undefined;
};

export const paramsConfig: ParamsConfigValidators = {
  page: numberValidation,
  search: stringValidation,
  sort: sortValidation,
  isActive: booleanValidation,
  userId: numberValidation,
  serviceId: numberValidation,
  barFilters: stringValidation,
  from: stringValidation,
  to: stringValidation,
  overdueOnly: booleanValidation
} as const;

export interface ParamsConfig {
  page: number;
  search: string;
  sort: Sorts;
  isActive: boolean;
  userId: number;
  serviceId: number;
  barFilters: string;
  from: string;
  to: string;
  overdueOnly: boolean;
}
